const accordion = async function () {
    if (document.querySelector(".accordion-company")) {
        const acc = document.querySelectorAll(".accordion-company__item");
        let i;

        for (i = 0; i < acc.length; i++) {
            acc[i].querySelector('.accordion-company__item__btn').onclick = function () {
                if (!this.querySelector('svg').classList.contains("rotate-[225deg]")) {
                    acc.forEach(item => {
                        item.querySelector('.accordion-company__item__bg').classList.remove("opacity-100");
                        item.querySelector('svg').classList.remove("rotate-[225deg]");
                        item.querySelector('.accordion-company__item__content').classList.remove("max-h-[500px]");
                        item.querySelector('.accordion-company_item_logo').classList.add("sm:opacity-0")
                    });
                }
                this.previousElementSibling.classList.toggle("opacity-100");
                this.querySelector('svg').classList.toggle("rotate-[225deg]");
                this.nextElementSibling.classList.toggle("max-h-[500px]");
                this.nextElementSibling.querySelector('.accordion-company_item_logo').classList.toggle("sm:opacity-0")
                console.log(this.nextElementSibling.querySelector('.accordion-company_item_logo'));
            }
        }
    }
}

export const init = accordion;